// goalConstants.js
'use strict';

export const type = {
  KARAOKE: 'karaoke',
  SHOW: 'show',
  SHOW_FUNDING: 'show-funding',
  LOTTERY: 'lottery',
};

// Self defined for UI different
export const karaokeType = {
  DEFAULT: 'default',
  TOY_DEVICE: 'toyDevice',
};
